module.exports = __webpack_public_path__ + "static/media/delantal (9).809ec937.jpg";